import React, { useState } from "react";
import { TextField, Button, Typography, Grid } from "@mui/material";
import {makeStyles} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import {useDispatch, useSelector} from "react-redux";
import {selectSupport, submitSupportRequest} from "./supportSlice";

const useStyles = makeStyles((theme) => ({
        container: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondaryFont.main,
            // width: "100%",
            height: "100%",
            padding: 50,
        },
        cardContainer: {
            backgroundColor: "#fff",
            borderRadius: 16,
            color: theme.palette.secondaryFont.main,
            padding: 32,
            maxWidth: 800,
            margin: "0 auto 50px",
        },
    paper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "45px",
        // backgroundColor: theme.palette.secondary.main,
        width: "100%",
    },
    topBackground: {
        // backgroundColor: theme.palette.secondary.main,
        // height: '100%',
    },
    form: {
        // borderBottom: '1px solid rgb(221, 221, 221)',

        marginTop: theme.spacing(1),
        width: "100%", // Fix IE 11 issue.
        color: theme.palette.secondaryFont.main,
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
    },
    textLabel: {
        fontSize: 20,
        fontWeight: "bold",
        marginBottom: 4,
        marginTop: 8,
    },
})
);

export default function SupportForm() {

    const classes = useStyles();

    let jwtToken = localStorage.getItem("clientToken");

    const dispatch = useDispatch();
    const { submitStatus } = useSelector(selectSupport);
    const { userAccount } = useSelector( (state) => state.users );

    const [attachment, setAttachment] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    function handleFileChange(e) {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        const maxBytes = 10 * 1024 * 1024; // 10MB
        const allowedMime = new Set([
            "image/png",
            "image/jpeg",
            "image/webp",
            "application/pdf",
            "text/plain",
            "application/msword", // .doc
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        ]);

        if (file.size > maxBytes) {
            alert("File must be 10MB or less.");
            e.target.value = "";
            return;
        }

        // MIME checks aren’t perfect, but better than nothing
        if (!allowedMime.has(file.type)) {
            alert("Allowed files: PNG/JPG/WEBP, PDF, DOC, DOCX, TXT.");
            e.target.value = "";
            return;
        }

        setAttachment(file); // you might rename this state to `attachment`
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        dispatch(
            submitSupportRequest({
            token: jwtToken,
            data: formData,
        }))
            .unwrap()
            .then(() => {
                e.currentTarget.reset();
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        /*
        <div
            style={{
                flexFlow: "row nowrap",
                justifyContent: "center",
            }}
            className={classes.container}
        >
        */
             <Paper className={classes.cardContainer} elevation={4}>
        <Grid className={classes.historyCardEdit}>
            <form className={classes.form} onSubmit={handleSubmit}
                  key={userAccount?.email || "support-form"}>
            <Typography variant="h5" gutterBottom>
                Request for Support
            </Typography>
                <p>For all queries about points allocation or the delivery of rewards,
                    please submit the form below and a team member will assist as soon as possible.</p>
            <div className={classes.textLabel}>First Name:</div>
                <TextField
                    defaultValue={userAccount?.firstName || ""}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="firstName"
                    name="firstName"
                    autoComplete="given-name"
                />
            <div className={classes.textLabel}>Last Name:</div>
                <TextField
                    defaultValue={userAccount?.lastName || ""}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="lastName"
                    name="lastName"
                    autoComplete="family-name"
                />
                <div className={classes.textLabel}>Usercode (if known):</div>
                <TextField
                    defaultValue={userAccount?.externalID || ""}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    id="usercode"
                    name="usercode"
                />
            <div className={classes.textLabel}>Email:</div>
                <TextField
                    defaultValue={userAccount?.email || ""}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="email"
                    name="email"
                    autoComplete="email"
                />
            <div className={classes.textLabel}>Phone Number:</div>
                <TextField
                    defaultValue={userAccount?.mobile || ""}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    id="phone"
                    name="phone"
                    autoComplete="tel"
                />
            <div className={classes.textLabel}>
                Details (including order number if relevant):
            </div>
                <TextField
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    multiline
                    minRows={4}
                    id="details"
                    name="details"
                />

            <div className={classes.textLabel}>Attachment (optional):</div>
            <Button variant="outlined" component="label">
                Choose file
                <input
                    type="file"
                    hidden
                    name="attachment"
                    onChange={handleFileChange}
                    accept="image/*,.pdf,.doc,.docx,.txt"
                />
            </Button>

            {attachment && (
                <div style={{ marginTop: 8 }}>
                    Selected: {attachment.name}
                </div>
            )}

            <div style={{ marginTop: 20 }}>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={submitStatus === "loading"}
                >
                    {submitStatus === "loading" ? "Submitting..." : "Submit"}
                </Button>
            </div>
        </form>
        </Grid>
             </Paper>
        /*
        </div>
             */
    );
}